export default __webpack_public_path__ + "static/duo-wide-2560-3f9a901926de93c635d48fd34a52fb38.jpg";